<ng-container #shellHost />

<div #dataRepresentation class="height-100">
    <div class="representation" [style.visibility]="isRepresentationVisible() ? null : 'hidden'">
        <ng-container #representationHost />
    </div>
    @if (loading() || hasError() || noData()) {
        <loading-and-error
            class="loading"
            [isLoading]="loading()"
            [hasError]="hasError()"
            [errorMessage]="errorMessage()"
            [hasNoData]="noData()"
        />
    }
</div>
